import { dataTestRoot } from "@/constants";
/**
 * @deprecated
 */
export const useTestId = (key) => `${dataTestRoot}.${key}`;
